(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateLanguageLinks = () => {
      const alternates = Array.from(document.querySelectorAll('link[rel="alternate"][hreflang]'));
      const currentTheme = window.Shopify?.theme;
      const previewThemeId = currentTheme && ['unpublished', 'development'].includes(currentTheme.role)
        ? String(currentTheme.id)
        : new URL(window.location.href).searchParams.get('preview_theme_id');
      document.querySelectorAll('[data-nc-language-link]').forEach((link) => {
        const destination = new URL(link.href);
        const language = link.getAttribute('hreflang');
        const alternate = alternates.find((candidate) => {
          const locale = candidate.getAttribute('hreflang').toLowerCase();
          const url = new URL(candidate.href, window.location.origin);
          return (locale === language || locale.startsWith(language + '-')) && url.origin === destination.origin;
        });
        const url = alternate ? new URL(alternate.href, window.location.origin) : destination;
        if (previewThemeId && /^\d+$/.test(previewThemeId)) {
          url.searchParams.set('preview_theme_id', previewThemeId);
        }
        link.href = url.href;
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateLanguageLinks, { once: true });
    } else {
      updateLanguageLinks();
    }
    document.addEventListener('shopify:section:load', updateLanguageLinks);
    document.addEventListener('click', (event) => {
      document.querySelectorAll('[data-nc-language-switcher][open]').forEach((details) => {
        if (!details.contains(event.target)) details.open = false;
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-nc-language-switcher][open]').forEach((details) => {
        const restoreFocus = details.contains(document.activeElement);
        details.open = false;
        if (restoreFocus) details.querySelector('summary').focus();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
